/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a vibrating screen feeder. State and labels are carried by the animatic primitive states and animatic labels, not here.
 */
export type AnimaticVibratingScreenFeederConfig = {
  /**
   * The screen incline in degrees; positive values raise the left end.
   */
  incline?: number | undefined;
  /**
   * Whether to draw vibration streak lines.
   */
  motion?: boolean | undefined;
  /**
   * The number of sieve decks drawn.
   */
  screens?: number | undefined;
};

/** @internal */
export const AnimaticVibratingScreenFeederConfig$inboundSchema: z.ZodType<
  AnimaticVibratingScreenFeederConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  incline: types.optional(types.number()),
  motion: types.optional(types.boolean()),
  screens: types.optional(types.number()),
});
/** @internal */
export type AnimaticVibratingScreenFeederConfig$Outbound = {
  incline?: number | undefined;
  motion?: boolean | undefined;
  screens?: number | undefined;
};

/** @internal */
export const AnimaticVibratingScreenFeederConfig$outboundSchema: z.ZodType<
  AnimaticVibratingScreenFeederConfig$Outbound,
  z.ZodTypeDef,
  AnimaticVibratingScreenFeederConfig
> = z.object({
  incline: z.number().optional(),
  motion: z.boolean().optional(),
  screens: z.number().int().optional(),
});

export function animaticVibratingScreenFeederConfigToJSON(
  animaticVibratingScreenFeederConfig: AnimaticVibratingScreenFeederConfig,
): string {
  return JSON.stringify(
    AnimaticVibratingScreenFeederConfig$outboundSchema.parse(
      animaticVibratingScreenFeederConfig,
    ),
  );
}
export function animaticVibratingScreenFeederConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticVibratingScreenFeederConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      AnimaticVibratingScreenFeederConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticVibratingScreenFeederConfig' from JSON`,
  );
}
